import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { IntegrationEndpoint, IntegrationEndpointCreate, IntegrationEndpointFilter } from '../data/integrationEndpoint';

export function createIntegrationEndpointService(client: AxiosInstance) {
  return createCrudService<IntegrationEndpoint, IntegrationEndpointCreate, IntegrationEndpointFilter>(
    client,
    '/integration/IntegrationEndpoint',
    'id',
  );
}

export type IntegrationEndpointService = CrudService<IntegrationEndpoint, IntegrationEndpointCreate, IntegrationEndpointFilter>;
